module.exports = __webpack_public_path__ + "img/49.a3c0d9cf.png";